import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { imgNbaLogo } from "../../assets";

export default function AuthScreenShell({
  children,
}: {
  children: React.ReactNode;
}) {
  const location = useLocation();
  const isSignup = location.pathname === "/signup";
  const prevIsSignupRef = React.useRef(isSignup);
  const [transitionClass, setTransitionClass] = React.useState<string>(
    isSignup
      ? "auth-screen__content--from-right"
      : "auth-screen__content--from-left"
  );

  React.useEffect(() => {
    const prev = prevIsSignupRef.current;
    if (prev !== isSignup) {
      setTransitionClass(
        isSignup
          ? "auth-screen__content--from-right"
          : "auth-screen__content--from-left"
      );
      prevIsSignupRef.current = isSignup;
    }
  }, [isSignup]);

  return (
    <div className="auth-screen min-h-screen">
      <div className="auth-screen__brand select-none">
        <img className="auth-screen__logo" src={imgNbaLogo} alt="NBA logo" />
        <div className="auth-screen__brand-text">
          <div className="auth-screen__brand-name">
            NIGERIAN BAR ASSOCIATION
          </div>
          <div className="auth-screen__brand-sub">REMUNERATION PORTAL</div>
        </div>
      </div>

      <div className="auth-screen__main">
        <div className="auth-screen__left">
          <h1 className="auth-screen__headline">
            {isSignup ? (
              <>Stay productive with Synclexs</>
            ) : (
              <>
                Official NBA Lagos
                <br />
                <span className="text-gray-400">Remuneration Portal</span>
              </>
            )}
          </h1>
        </div>

        <div className="auth-screen__card shadow-[var(--card-shadow)] rounded-2xl overflow-hidden">
          <div className="auth-tabs" aria-label="Authentication">
            <NavLink
              to="/signup"
              className={({ isActive }) =>
                isActive
                  ? "auth-tabs__tab auth-tabs__tab--active"
                  : "auth-tabs__tab"
              }
            >
              Sign Up
            </NavLink>
            <NavLink
              to="/login"
              end
              className={({ isActive }) =>
                isActive
                  ? "auth-tabs__tab auth-tabs__tab--active"
                  : "auth-tabs__tab"
              }
            >
              Login
            </NavLink>
          </div>

          <div
            key={location.pathname}
            className={`auth-screen__content ${transitionClass} will-change-transform`}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
